import { render, staticRenderFns } from "./stock-kline.vue?vue&type=template&id=3ce4565e"
import script from "./stock-kline.vue?vue&type=script&lang=js"
export * from "./stock-kline.vue?vue&type=script&lang=js"
import style0 from "./stock-kline.vue?vue&type=style&index=0&id=3ce4565e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports